import * as React from "react";

import { Container, Row, Col } from "react-bootstrap";
const bodhitree_icon = "/images/Bodhilogo.svg";
import { useMediaQuery } from "react-responsive";
import email_icon from "./assets/email_icon.webp";
import trust_edge_footer_logo from "./assets/trust_edge_footer_logo.webp";
import phone_icon from "./assets/phone_icon.webp";
import FooterTrustItem from "Screens_old/FooterTrustItem/FooterTrustItem";
import styles from "./FooterTrust.module.css";
import { classNames } from "Store/utils";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const FooterTrust = () => {
  const medium = useMediaQuery({ query: "(min-width: 768px)" });
  const phoneNumber = '+91-7021050835';
  const emailAddress = 'contactus-trustedge@cse.iitb.ac.in';

  const handleEmailClick = (e) => {
    window.location.href = `mailto:${emailAddress}`;
  };

  return medium ? (
    <Container
      fluid
      className={classNames("m-0 p-0", styles.footerContainer, "d-flex flex-column")}
    >
      {/* Main Footer Sections Row */}
      <Row className="m-0 py-3 px-5">
        <Col md={12}>
          {/* Logo and Tagline Row */}
          <Row className="mb-4">
            <Col md={12} className="d-flex align-items-center gap-3">
              <a
                href="https://trustlab.iitb.ac.in/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.logoLink}
              >
                <img
                  className={classNames("d-inline-block align-top", styles.trustLabLogoSmall)}
                  src={trust_edge_footer_logo}
                  alt="IITB Trust Lab Logo"
                />
              </a>
              <p className={classNames(styles.tagline, "mb-0")}>
                An Education Outreach initiative of IITB Trust Lab
              </p>
            </Col>
          </Row>

          {/* Three Column Layout: Quick Links, Contact Us, Follow Us */}
          <Row>
            {/* Column 1: Quick Links */}
            <Col md={4} className="d-flex flex-column">
              <h6 className={styles.sectionHeader}>Quick Links</h6>
              <div className={styles.quickLinksSection}>
                <FooterTrustItem
                  url="/terms"
                  childComp={
                    <span className={styles.quickLink}>
                      Terms Of Use
                    </span>
                  }
                />
                <FooterTrustItem
                  url="/privacy"
                  childComp={
                    <span className={styles.quickLink}>
                      Privacy Policy
                    </span>
                  }
                />
                <FooterTrustItem
                  url="https://docs.google.com/document/d/1kTVJY8_fhmI8pOzuYLL3Kq804DPN0mJNwokuiFq8OD8/edit?tab=t.0"
                  openInNewTab={true}
                  childComp={
                    <span className={styles.quickLink}>
                      FAQ
                    </span>
                  }
                />
              </div>
            </Col>

            {/* Column 2: Contact Us */}
            <Col md={4} className="d-flex flex-column">
              <h6 className={styles.sectionHeader}>Contact Us</h6>
              <div className={styles.contactSection} style={{ alignItems: "flex-start" }}>
                <div className={styles.contactItem}>
                  <img
                    src={phone_icon}
                    className={styles.contactIcon}
                    alt="phone icon"
                  />
                  <a
                    href={`tel:${phoneNumber}`}
                    className={classNames(styles.contactLink, styles.phoneLink)}
                  >
                    {phoneNumber}
                  </a>
                </div>
                <div className={styles.contactItem}>
                  <img
                    src={email_icon}
                    className={styles.contactIcon}
                    alt="email icon"
                  />
                  <a
                    href={`mailto:${emailAddress}`}
                    onClick={handleEmailClick}
                    className={classNames(styles.contactLink, styles.emailLink)}
                  >
                    {emailAddress}
                  </a>
                </div>
                <div className={styles.contactItem}>
                  <LocationOnIcon
                    style={{ fontSize: "18px", color: "#343a40" }}
                  />
                  <a
                    href="https://www.google.com/maps/place/Department+of+Computer+Science+and+Engineering,+IIT+Bombay/@19.1303305,72.9132363,17z/data=!3m1!4b1!4m6!3m5!1s0x3be7c7f68f86c501:0xb2e556c563a19541!8m2!3d19.1303305!4d72.9158112!16s%2Fg%2F11c0phnwzg?entry=tts&g_ep=EgoyMDI1MDYxMS4wIPu8ASoASAFQAw%3D%3D&skid=1c0c92b5-08c3-4f72-b09c-64191a2b1afd"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classNames(styles.contactLink, styles.addressLink)}
                  >
                    Department of Computer Science<br />
                    Engineering, IIT Bombay, Powai,<br />
                    Mumbai - 400076
                  </a>
                </div>
              </div>
            </Col>

            {/* Column 3: Follow Us */}
            <Col md={4} className="d-flex flex-column">
              <h6 className={styles.sectionHeader}>Follow Us</h6>
              <div className={styles.socialSection}>
                <a
                  href="https://www.linkedin.com/company/109378313/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className={styles.socialIcon}
                >
                  <LinkedInIcon style={{ fontSize: "28px", color: "#343a40" }} />
                </a>
                <a
                  href="https://www.instagram.com/iitbom_trustedge/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className={styles.socialIcon}
                >
                  <InstagramIcon style={{ fontSize: "28px", color: "#343a40" }} />
                </a>
                <a
                  href="https://x.com/IITBTrustEdge"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                  className={styles.socialIcon}
                >
                  <TwitterIcon style={{ fontSize: "28px", color: "#343a40" }} />
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61581493435237"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className={styles.socialIcon}
                >
                  <FacebookIcon style={{ fontSize: "28px", color: "#343a40" }} />
                </a>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Acknowledgment and Powered By Section - Above the line */}
      <Row className="m-0 pt-4 pb-3 px-5">
        <Col md={12} className="d-flex justify-content-between align-items-center">
          <span
            style={{
              color: "#495057",
              fontSize: "15px",
              letterSpacing: "0.4px",
              lineHeight: "1.6",
              flex: "1",
              paddingRight: "20px"
            }}
          >
            Graciously supported by Tower Research Capital,
            towards inclusive, technology-driven hands-on learning.
          </span>
          <div className="d-flex align-items-center gap-2 flex-shrink-0">
            <span
              style={{
                color: "#495057",
                fontWeight: "600",
                fontSize: "13px",
                letterSpacing: "0.5px"
              }}
            >
              Powered By
            </span>
            <img
              className={styles.qrCode}
              src={bodhitree_icon}
              alt="Bodhitree Logo"
              style={{
                cursor: "pointer",
                width: "75px",
                height: "auto",
                filter: "brightness(1.1) contrast(1.1)"
              }}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            />
          </div>
        </Col>
      </Row>

      {/* Bottom Section - Copyright */}
      <Row className={classNames("m-0 py-2", styles.borderTop)}>
        <Col md={12} className="d-flex justify-content-center align-items-center">
          <span className={styles.copyright}>Copyright @ 2024 Bodhitree, All Rights Reserved</span>
        </Col>
      </Row>
    </Container>
  ) : (
    <Container
      fluid
      className={classNames("m-0 p-0", styles.footerContainer, "d-flex flex-column")}
    >
      {/* Logo and Tagline Row - Mobile */}
      <Row className="m-0 py-3 px-3">
        <Col xs={12} className="mb-3">
          <a
            href="https://trustlab.iitb.ac.in/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.logoLink}
          >
            <img
              className={classNames("d-inline-block align-top", styles.trustLabLogoSmall)}
              src={trust_edge_footer_logo}
              alt="IITB Trust Lab Logo"
            />
          </a>
          <p className={classNames(styles.tagline, "mt-2 mb-0")}>
            An Education Outreach initiative of IITB Trust Lab
          </p>
        </Col>
      </Row>

      {/* Three Sections for Mobile */}
      <Row className="m-0 px-3 pb-3">
        <Col xs={12}>
          {/* Quick Links */}
          <div className="mb-3">
            <h6 className={styles.sectionHeader}>Quick Links</h6>
            <div className={styles.quickLinksSection}>
              <FooterTrustItem
                url="/terms"
                childComp={
                  <span className={styles.quickLink}>
                    Terms Of Use
                  </span>
                }
              />
              <FooterTrustItem
                url="/privacy"
                childComp={
                  <span className={styles.quickLink}>
                    Privacy Policy
                  </span>
                }
              />
              <FooterTrustItem
                url="https://docs.google.com/document/d/1kTVJY8_fhmI8pOzuYLL3Kq804DPN0mJNwokuiFq8OD8/edit?tab=t.0"
                openInNewTab={true}
                childComp={
                  <span className={styles.quickLink}>
                    FAQ
                  </span>
                }
              />
            </div>
          </div>

          {/* Contact Us */}
          <div className="mb-3">
            <h6 className={styles.sectionHeader}>Contact Us</h6>
            <div className={styles.contactSection} style={{ alignItems: "flex-start", gap: "8px" }}>
              <div className={styles.contactItem}>
                <img
                  src={phone_icon}
                  className={styles.contactIcon}
                  alt="Phone"
                />
                <a
                  href={`tel:${phoneNumber}`}
                  className={classNames(styles.contactLink, styles.phoneLink)}
                >
                  +91 7021050835
                </a>
              </div>
              <div className={styles.contactItem}>
                <img
                  src={email_icon}
                  className={styles.contactIcon}
                  alt="Email"
                />
                <a
                  href={`mailto:${emailAddress}`}
                  className={classNames(styles.contactLink, styles.emailLink)}
                >
                  {emailAddress}
                </a>
              </div>
              <div className={styles.contactItem}>
                <LocationOnIcon
                  style={{ fontSize: "12px", color: "#343a40", marginRight: "5px" }}
                />
                <a
                  href="https://www.google.com/maps/place/Department+of+Computer+Science+and+Engineering,+IIT+Bombay/@19.1303305,72.9132363,17z/data=!3m1!4b1!4m6!3m5!1s0x3be7c7f68f86c501:0xb2e556c563a19541!8m2!3d19.1303305!4d72.9158112!16s%2Fg%2F11c0phnwzg?entry=tts&g_ep=EgoyMDI1MDYxMS4wIPu8ASoASAFQAw%3D%3D&skid=1c0c92b5-08c3-4f72-b09c-64191a2b1afd"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classNames(styles.contactLink, styles.addressLink)}
                >
                  Department of Computer Science<br />
                  Engineering, IIT Bombay, Powai,<br />
                  Mumbai - 400076
                </a>
              </div>
            </div>
          </div>

          {/* Follow Us */}
          <div>
            <h6 className={styles.sectionHeader}>Follow Us</h6>
            <div className="d-flex flex-wrap justify-content-start align-items-center gap-2">
              <a
                href="https://www.linkedin.com/company/109378313/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className={styles.socialIcon}
              >
                <LinkedInIcon style={{ fontSize: "18px", color: "#343a40" }} />
              </a>
              <a
                href="https://www.instagram.com/iitbom_trustedge/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className={styles.socialIcon}
              >
                <InstagramIcon style={{ fontSize: "18px", color: "#343a40" }} />
              </a>
              <a
                href="https://x.com/IITBTrustEdge"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
                className={styles.socialIcon}
              >
                <TwitterIcon style={{ fontSize: "18px", color: "#343a40" }} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61581493435237"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className={styles.socialIcon}
              >
                <FacebookIcon style={{ fontSize: "18px", color: "#343a40" }} />
              </a>
            </div>
          </div>
        </Col>
      </Row>

      {/* Acknowledgment Section - Mobile */}
      <Row className={classNames("m-0 pt-4 pb-3 px-3", styles.borderTop)}>
        <Col xs={12} className="d-flex justify-content-center align-items-center">
          <span
            style={{
              color: "#495057",
              fontSize: "11px",
              letterSpacing: "0.4px",
              lineHeight: "1.6",
              textAlign: "center"
            }}
          >
            Graciously supported by Tower Research Capital,<br />
            towards inclusive, technology-driven hands-on learning.
          </span>
        </Col>
      </Row>

      {/* Powered By and Copyright Section - Mobile */}
      <Row className="m-0 py-3 px-3">
        <Col xs={9} className="d-flex justify-content-start align-items-center">
          <span className={styles.copyright}>Copyright @ 2024 Bodhitree, All Rights Reserved</span>
        </Col>
        <Col xs={3} className="d-flex justify-content-end align-items-center">
          <div className="d-flex flex-column align-items-center">
            <span
              style={{
                color: "#495057",
                fontWeight: "600",
                fontSize: "11px",
                letterSpacing: "0.5px",
                marginBottom: "6px"
              }}
            >
              Powered By
            </span>
            <img
              className={styles.qrCode}
              src={bodhitree_icon}
              alt="Bodhitree Logo"
              style={{ cursor: "pointer", width: "50px", height: "50px" }}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default FooterTrust;